import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import { listFn } from 'api/tool/record';
export default {
  data: function data() {
    return {
      dataForm: {
        operate_mobile: '',
        user_mobile: ''
      },
      pageSizes: [100, 50, 20],
      page: {
        list: [],
        currPage: 1,
        limit: 100,
        total: 0
      },
      dataRule: {
        operate_mobile: [{
          required: true,
          message: this.$t('303')
        }],
        user_mobile: [{
          required: true,
          message: this.$t('304')
        }]
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState({
    contentViewHeight: function contentViewHeight(state) {
      return state.settings.contentViewHeight;
    }
  })), {}, {
    tableHeight: function tableHeight() {
      return this.contentViewHeight - 180;
    }
  }),
  methods: {
    getTableList: function getTableList() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return listFn({
                operate_mobile: _this.dataForm.operate_mobile,
                user_mobile: _this.dataForm.user_mobile,
                page: _this.page.currPage,
                page_size: _this.page.limit
              });
            case 2:
              res = _context.sent;
              if (res && res.code === 1) {
                _this.page.list = res.data.list;
                _this.page.total = res.data.count;
              }
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // 每页条数
    sizeChangeHandle: function sizeChangeHandle(val) {
      this.page.limit = val;
      this.getTableList();
    },
    // 切换 页
    currentChangeHandle: function currentChangeHandle(val) {
      this.page.currPage = val;
      this.getTableList();
    }
  }
};